import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateShedCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { shed } = improvementsForTransaction;
  const {
    address: { PostalCode: zipCode },
  } = identification;

  if (!shed || !shed.area || isUndefined(shed.quality) || isUndefined(zipCode)) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getShedCost({
    hasFeature: ORDER_FEATURES.shed.hasFeature(improvementsForTransaction),
    sqft: AloftArea.schema.parse(shed.area),
    quality: shed.quality,
    zipCode,
  });
};

export const { selectShedCost, selectZipOnlyShedCost, selectShedCosts, selectShedCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculateShedCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectShedCost',
      zipOnly: 'selectZipOnlyShedCost',
      costs: 'selectShedCosts',
      display: 'selectShedCostDisplay',
    },
  });
